'use client';

import { useReducedMotion } from 'motion/react';

import { AudienceResearchCanvas } from '~/components/landing/audience-research-scene';
import { ExampleShortlist } from '~/components/landing/example-shortlist';
import { IntelligenceExplorerPreview } from '~/components/landing/intelligence-explorer-previews';
import { OperationalIntelligenceCanvas } from '~/components/landing/operational-intelligence-previews';
import type { Capability } from '~/lib/capabilities';

/** Use the same scenes as the homepage, without another capability selector. */
export function CapabilityPreview({
  number
}: {
  number: Capability['number'];
}) {
  const reduced = !!useReducedMotion();

  if (number === '01') {
    return (
      <ExampleShortlist
        mode="Prospecting"
        showPersonas={false}
        embedded
        cycleModeExamples
      />
    );
  }

  if (number === '02') {
    return (
      <IntelligenceExplorerPreview
        previewNumber={number}
        reduced={reduced}
        compactHeader
      />
    );
  }

  return (
    <div className="overflow-hidden rounded-[22px] border border-[color:var(--hairline)] bg-[color:var(--paper)] shadow-[0_20px_55px_rgba(32,26,20,0.065)]">
      {number === '03' ? (
        <AudienceResearchCanvas reduced={reduced} />
      ) : (
        <OperationalIntelligenceCanvas
          previewNumber={number}
          reduced={reduced}
        />
      )}
    </div>
  );
}
